import {
  clientPortalAdminTipAssetUrl,
  DashboardTipsAdminGrid,
  type DashboardTipsAdminApi
} from '@jarvis/platform-ui';
import { useMemo } from 'react';
import {
  CLIENT_PORTAL_DASHBOARD_TIPS_API_BASE,
  createDashboardTipsAdminApi,
  PORTAL_TIP_DEFAULT_MIN_ROLE,
  PORTAL_TIP_MIN_ROLE_OPTIONS
} from '../../../api/dashboardTips';

export function ClientPortalDashboardTipsAdminPage() {
  const api = useMemo<DashboardTipsAdminApi>(
    () => createDashboardTipsAdminApi(CLIENT_PORTAL_DASHBOARD_TIPS_API_BASE),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <DashboardTipsAdminGrid
          api={api}
          stateStorageKey="webopsui:client-portal-dashboard-tips-grid"
          minRoleOptions={PORTAL_TIP_MIN_ROLE_OPTIONS}
          defaultMinRole={PORTAL_TIP_DEFAULT_MIN_ROLE}
          assetUrl={clientPortalAdminTipAssetUrl}
        />
      </div>
    </div>
  );
}
